var SENTRY_RELEASE;SENTRY_RELEASE={name: "Efort Coach", version: "1.0.0"};